import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let MerchantsList = class MerchantsList extends Mixins(ViewportSizeMixin) {
    testimonials() {
        const testimonials = [
            {
                testimonial: `Our group was born during the pandemic as a simple online 
                      market. Though our platform was digital thru FB and IG, our 
                      order processing were still manual and requires full attention 
                      to fulfill transactions. This led us to explore partnership with 
                      ChatGenie. The system is so practical, we were able to enhance our 
                      ordering system in FB messenger which is well known by our existing 
                      customers. Thanks to ChatGenie that gave us this advantage in the market. 
                      We’re looking forward for more features as the whole system has lots of 
                      potential especially on this digital era where being online is not anymore
                      an option but rather a necessity for everyone.`,
                name: 'RM Panganiban',
                position: 'Marketitos and Titas Owner',
                img: `${S3_ASSETS_BUCKET_URL}/testimonials-marketitos.png`,
            },
            {
                testimonial: `Our small business had a hard time during quarantine when online 
                      orders surged. Our limited manpower couldn’t handle the large number 
                      of inquiries. Chat Genie made it easy and convenient for us to track 
                      orders and customers. Thank you, Chat Genie!`,
                name: 'Martha Nikko Comia',
                position: 'Marikina Bakery Owner',
                img: `${S3_ASSETS_BUCKET_URL}/testimonials-marikina-bakery.png`,
            },
            {
                testimonial: `The pandemic has resulted in customers needing access to a 
                      variety of products from the convenience and safety of their homes, 
                      and with ChatGenie, it enabled us to continue operations in spite of 
                      contact restrictions. ChatGenie has been really helpful for us to 
                      continue and even increase our market share amidst the pandemic. The 
                      application allows us to take orders efficiently and more organized. 
                      I also think that ChatGenie helped our loyal and new customers to order 
                      their favorite meats easily at the comfort and safety of their homes 
                      especially for rush deliveries since the credit card facility allows for 
                      instant checkout and dispatching of orders. The interface is also user 
                      friendly for the team and is able to collect data for sales planning.`,
                name: 'Pau Bartolomo',
                position: 'PrimeBeef Co. Sales',
                img: `${S3_ASSETS_BUCKET_URL}/testimonials-primebeef.png`,
            },
            {
                testimonial: `It has helped us get orders in the middle of the night and early morning. 
                      For daytime, it has helped increase the basket size as customers tend to order 
                      more on the app.`,
                name: 'Jon Bendicion',
                position: 'Bravour PH',
                img: `${S3_ASSETS_BUCKET_URL}/testimonials-bravour.png`,
            },
            {
                testimonial: `ChatGenie has helped us a lot in reaching our customers especially 
                      after pandemic hit our physical business. It’s so easy to get into. 
                      When we saw the Youtube tutorials, it took us 24 to 48 hours to make it 
                      happen. Chat Genie allowed an easy ordering portal that is familiar and 
                      readily available to our customers. More importantly, ChatGenie Team always 
                      seeks to improve the features offered by the app. The service they provide 
                      their merchants is outstanding as always. Keep it up ChatGenie and more power 
                      to all of you.`,
                name: 'AJT Concepts',
                position: 'JIN-ZAI Owner',
                img: `${S3_ASSETS_BUCKET_URL}/testimonials-jin-zai.png`,
            },
            {
                testimonial: `At the onset of the pandemic, it was a win for us to be able to get 
                      lots of orders for essential goods. That was a bit challenging though 
                      since we had to do our order taking in Facebook messenger manually. When we 
                      tried Chatgenie, it saved us hours of manual work! Up to now, it’s been a 
                      quick and easy way to try selling products via Facebook especially if you still 
                      don’t have the resources to create your own ecommerce website. I also appreciate 
                      that the Chatgenie Support is responsive with our inquiries and issues. Way to 
                      go Chatgenie!`,
                name: 'Krishia',
                position: 'Refill on the Road Co-Founder',
                img: `${S3_ASSETS_BUCKET_URL}/testimonials-refills-on-the-road.png`,
            },
            {
                testimonial: `As we all know, the pandemic had a huge effect on all of us. This being said,
                      the support that ChatGenie gave us really helped in expanding our reach and 
                      helped us provide an easy and fast shopping experience for our customers. 
                      Currently we like the state we are at and ChatGenie helped us reach more clients 
                      as it is used through Facebook. We hope you help more establishments and our team 
                      appreciates what the app offers. We would also like to personally thank you guys 
                      for the support you have given us whenever we raise technical difficulties. It 
                      just shows that you are really dedicated in making the users and merchants have 
                      the best experience with the ChatGenie app.`,
                name: 'Jonathan',
                position: 'EcoSci Food Inc',
                img: `${S3_ASSETS_BUCKET_URL}/testimonials-eco-sci-food.png`,
            },
        ];
        if (this.$route.path === '/') {
            return testimonials.filter((_, key) => key < 4);
        }
        return testimonials;
    }
    get merchantsList() {
        return [
            'goldilocks.png',
            'potato-corner.png',
            'manilachon.png',
            'prime-beef-company.png',
            'crazy-acres.png',
            'globe.png',
            'cat.png',
            'century-mall.png',
            'eastwood-mall.png',
            'festive-walk-iloilo.png',
            'lucky-chinatown.png',
            'southwoods-mall.png',
        ].map((img) => `${S3_ASSETS_BUCKET_URL}/${img}`);
    }
};
MerchantsList = __decorate([
    Component
], MerchantsList);
export default MerchantsList;
